/* Wild Trail theme scripts — no dependencies */
(function () {
  'use strict';
  var T = window.WildTrailTheme || { routes: {}, strings: {} };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* Header: solid glass once the page scrolls */
  var headerWrap = $('[data-header]');
  if (headerWrap) {
    var onScroll = function () { headerWrap.classList.toggle('is-stuck', window.scrollY > 12); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Mobile drawer */
  var drawer = $('[data-drawer]');
  var lastFocus = null;
  function setDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.documentElement.style.overflow = open ? 'hidden' : '';
    $$('[data-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    if (open) { lastFocus = document.activeElement; var f = $('[data-drawer-close]', drawer); if (f) f.focus(); }
    else if (lastFocus) { lastFocus.focus(); }
  }
  $$('[data-drawer-open]').forEach(function (b) { b.addEventListener('click', function () { setDrawer(true); }); });
  $$('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', function () { setDrawer(false); }); });

  /* Search overlay */
  var search = $('[data-search]');
  function setSearch(open) {
    if (!search) return;
    search.hidden = !open;
    document.documentElement.style.overflow = open ? 'hidden' : '';
    if (open) { var i = $('input', search); if (i) setTimeout(function () { i.focus(); }, 30); }
  }
  $$('[data-search-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); setSearch(true); }); });
  $$('[data-search-close]').forEach(function (b) { b.addEventListener('click', function () { setSearch(false); }); });
  if (search) search.addEventListener('click', function (e) { if (e.target === search) setSearch(false); });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (search && !search.hidden) setSearch(false);
    if (drawer && drawer.classList.contains('is-open')) setDrawer(false);
  });

  /* Reveal on scroll */
  var revealEls = $$('[data-reveal]');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* Tabs */
  $$('[data-tabs]').forEach(function (root) {
    var btns = $$('[role="tab"]', root);
    var panels = $$('[role="tabpanel"]', root);
    function select(i, focus) {
      btns.forEach(function (b, n) { b.setAttribute('aria-selected', n === i ? 'true' : 'false'); b.tabIndex = n === i ? 0 : -1; });
      panels.forEach(function (p, n) { p.hidden = n !== i; });
      var url = $('[data-frame-url]', root);
      if (url && btns[i]) url.textContent = btns[i].getAttribute('data-url') || url.textContent;
      if (focus) btns[i].focus();
    }
    btns.forEach(function (b, i) {
      b.addEventListener('click', function () { select(i); });
      b.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') select((i + 1) % btns.length, true);
        if (e.key === 'ArrowLeft') select((i - 1 + btns.length) % btns.length, true);
      });
    });
  });

  /* Toast */
  var toast = $('[data-toast]');
  var toastTimer = null;
  function showToast(msg) {
    if (!toast) return;
    $('[data-toast-text]', toast).textContent = msg;
    toast.hidden = false;
    requestAnimationFrame(function () { toast.classList.add('is-on'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('is-on'); setTimeout(function () { toast.hidden = true; }, 400); }, 4200);
  }

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; el.hidden = !count; });
  }

  /* Quantity steppers */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var wrap = b.closest('.qty');
    var input = wrap && $('input', wrap);
    if (!input) return;
    var min = parseInt(input.min || '0', 10);
    var v = (parseInt(input.value, 10) || 0) + (b.getAttribute('data-qty') === 'plus' ? 1 : -1);
    input.value = Math.max(min, v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Cart page: submit when a quantity changes */
  $$('[data-cart-form] .qty input').forEach(function (input) {
    var t = null;
    input.addEventListener('change', function () {
      clearTimeout(t);
      t = setTimeout(function () { input.form.submit(); }, 450);
    });
  });

  /* Collection sort / filter: submit on change */
  $$('[data-autosubmit]').forEach(function (form) {
    form.addEventListener('change', function (e) {
      if (e.target.matches('input[type="number"]')) return;
      form.submit();
    });
  });

  /* Product form */
  $$('[data-product]').forEach(function (root) {
    var dataEl = $('script[data-product-json]', root);
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var form = $('form.product-form', root);
    var idInput = form && $('input[name="id"]', form);
    var addBtn = form && $('[data-add]', form);
    var addLabel = addBtn && $('[data-add-label]', addBtn);
    var msg = $('[data-form-msg]', root);
    var money = function (cents) {
      var fmt = root.getAttribute('data-money-format') || '${{amount}}';
      var v = (cents / 100).toFixed(2);
      var parts = v.split('.');
      var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
        if (k === 'amount_no_decimals') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        if (k === 'amount_with_comma_separator') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
        return withCommas;
      });
    };

    function currentOptions() {
      return $$('fieldset[data-option]', root).map(function (fs) {
        var c = $('input:checked', fs);
        return c ? c.value : null;
      });
    }

    function findVariant(opts) {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function markAvailability(opts) {
      $$('fieldset[data-option]', root).forEach(function (fs, idx) {
        $$('input', fs).forEach(function (inp) {
          var test = opts.slice(); test[idx] = inp.value;
          var v = findVariant(test);
          inp.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }

    function goToMedia(mediaId) {
      if (!mediaId) return;
      var slide = $('[data-media-id="' + mediaId + '"]', root);
      if (slide) showSlide($$('[data-slide]', root).indexOf(slide));
    }

    function onChange() {
      var opts = currentOptions();
      $$('fieldset[data-option]', root).forEach(function (fs, i) {
        var lbl = $('[data-selected]', fs); if (lbl) lbl.textContent = opts[i] || '';
      });
      markAvailability(opts);
      var v = findVariant(opts);
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addLabel.textContent = T.strings.unavailable; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (addBtn) { addBtn.disabled = !v.available; addLabel.textContent = v.available ? T.strings.addToCart : T.strings.soldOut; }
      $$('[data-price-now]', root).forEach(function (el) { el.textContent = money(v.price); });
      var on = v.compare_at_price && v.compare_at_price > v.price;
      $$('[data-price-was]', root).forEach(function (el) { el.hidden = !on; el.textContent = on ? money(v.compare_at_price) : ''; });
      $$('[data-price-save]', root).forEach(function (el) {
        el.hidden = !on;
        if (on) el.textContent = el.textContent.replace(/\d+%/, Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%');
      });
      if (v.featured_media) goToMedia(v.featured_media.id);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    $$('fieldset[data-option] input', root).forEach(function (inp) { inp.addEventListener('change', onChange); });
    if ($$('fieldset[data-option]', root).length) markAvailability(currentOptions());

    /* Gallery */
    var slides = $$('[data-slide]', root);
    var thumbs = $$('[data-thumb]', root);
    var active = Math.max(0, slides.findIndex(function (s) { return s.classList.contains('is-active'); }));
    function showSlide(i) {
      if (!slides.length) return;
      i = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        s.classList.toggle('is-active', n === i);
        if (n !== i) { var vid = $('video', s); if (vid) vid.pause(); }
      });
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      active = i;
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { showSlide(i); }); });
    $$('[data-gal-prev]', root).forEach(function (b) { b.addEventListener('click', function () { showSlide(active - 1); }); });
    $$('[data-gal-next]', root).forEach(function (b) { b.addEventListener('click', function () { showSlide(active + 1); }); });
    var main = $('.gallery__main', root);
    if (main) {
      var sx = 0;
      main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) showSlide(active + (dx < 0 ? 1 : -1));
      }, { passive: true });
    }

    /* Add to cart via AJAX, with a normal form post as the fallback */
    if (form && window.fetch) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtn) { addBtn.disabled = true; addBtn.setAttribute('aria-busy', 'true'); }
        if (msg) msg.hidden = true;
        fetch(T.routes.cartAdd, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.d.description || res.d.message || T.strings.error);
            showToast(T.strings.added);
            return fetch(T.routes.cart, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
          })
          .then(function (cart) { if (cart) updateCartCount(cart.item_count); })
          .catch(function (err) { if (msg) { msg.textContent = err.message; msg.hidden = false; } })
          .finally(function () { if (addBtn) { addBtn.disabled = false; addBtn.removeAttribute('aria-busy'); } onChange(); });
      });
    }

    /* Sticky buy bar on phones */
    var sticky = $('[data-sticky-buy]', root);
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        sticky.classList.toggle('is-on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
      }).observe(addBtn);
      $('[data-sticky-add]', sticky).addEventListener('click', function () { addBtn.click(); });
    }
  });

  /* Related products (Shopify recommendations API) */
  $$('[data-recs]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url || !window.fetch) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var inner = $('[data-recs]', tmp);
      if (inner && inner.innerHTML.trim().length) {
        el.innerHTML = inner.innerHTML;
        $$('[data-reveal]', el).forEach(function (n) { n.classList.add('is-in'); });
      }
    });
  });
})();

/* ---- Wild Trail Nino: motion (header, back-to-top ring, parallax, word fill, counters, tilt, cursor) ---- */
(function () {
  'use strict';
  var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  var header = document.querySelector('[data-header]');
  var toTop = document.querySelector('[data-to-top]');
  var px = calm ? [] : $$('[data-parallax]');
  var fills = $$('[data-fill]');
  var lastY = window.scrollY, ticking = false;

  /* Split text blocks into words for the scroll-driven fill effect */
  fills.forEach(function (el) {
    var words = el.textContent.trim().split(/\s+/);
    el.textContent = '';
    words.forEach(function (w, i) {
      var s = document.createElement('span');
      s.className = 'fill-word';
      s.textContent = w;
      el.appendChild(s);
      if (i < words.length - 1) el.appendChild(document.createTextNode(' '));
    });
    el._words = $$('.fill-word', el);
  });

  function onFrame() {
    ticking = false;
    var y = window.scrollY, vh = window.innerHeight;
    var h = document.documentElement.scrollHeight - vh;
    if (header) {
      if (y > 240 && y > lastY + 2) header.classList.add('is-hidden');
      if (y < lastY - 2 || y < 240) header.classList.remove('is-hidden');
    }
    lastY = y;
    if (toTop) {
      toTop.classList.toggle('is-on', y > vh * 0.6);
      toTop.style.setProperty('--p', h > 0 ? Math.min(100, (y / h) * 100).toFixed(1) : 0);
    }
    px.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      var t = (r.top + r.height / 2 - vh / 2) / vh;
      var img = el.querySelector('img');
      if (img) img.style.translate = '0 ' + (t * -5).toFixed(2) + '%';
    });
    fills.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < -vh || r.top > vh * 2) return;
      /* progress 0 when block top hits 85% of viewport, 1 when its bottom reaches 45% */
      var p = calm ? 1 : (vh * 0.85 - r.top) / (r.height + vh * 0.4);
      p = Math.max(0, Math.min(1, p));
      var n = Math.round(p * el._words.length);
      el._words.forEach(function (w, i) { w.classList.toggle('is-lit', i < n); });
    });
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(onFrame); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  onFrame();

  if (toTop) toTop.addEventListener('click', function (e) {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: calm ? 'auto' : 'smooth' });
  });

  /* Count-up numbers */
  var counters = $$('[data-count]');
  function run(el) {
    var end = parseInt(el.getAttribute('data-count'), 10) || 0;
    if (calm || end === 0) { el.textContent = end; return; }
    var start = null, dur = 1600;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min(1, (ts - start) / dur);
      el.textContent = Math.round(end * (1 - Math.pow(1 - p, 3)));
      if (p < 1) requestAnimationFrame(step);
    }
    el.textContent = '0';
    requestAnimationFrame(step);
  }
  if ('IntersectionObserver' in window && counters.length) {
    var co = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { run(e.target); co.unobserve(e.target); } });
    }, { threshold: 0.6 });
    counters.forEach(function (c) { co.observe(c); });
  }

  /* Hero photo: follows the mouse with a gentle 3D tilt */
  if (fine && !calm) $$('[data-tilt]').forEach(function (card) {
    var zone = card.closest('section') || card;
    zone.addEventListener('pointermove', function (e) {
      var r = zone.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5;
      var y = (e.clientY - r.top) / r.height - 0.5;
      card.style.setProperty('--tx', (x * 14).toFixed(2) + 'deg');
      card.style.setProperty('--ty', (y * -10).toFixed(2) + 'deg');
    });
    zone.addEventListener('pointerleave', function () {
      card.style.setProperty('--tx', '0deg');
      card.style.setProperty('--ty', '0deg');
    });
  });

  /* "View" bubble that follows the cursor over project cards */
  if (fine && !calm) {
    var targets = $$('[data-cursor]');
    if (targets.length) {
      var bub = document.createElement('div');
      bub.className = 'cursor-bubble';
      bub.setAttribute('aria-hidden', 'true');
      document.body.appendChild(bub);
      var bx = 0, by = 0, cx = 0, cy = 0, raf = null;
      function loop() {
        cx += (bx - cx) * 0.2; cy += (by - cy) * 0.2;
        bub.style.transform = 'translate(' + cx.toFixed(1) + 'px,' + cy.toFixed(1) + 'px)';
        raf = Math.abs(bx - cx) + Math.abs(by - cy) > 0.3 ? requestAnimationFrame(loop) : null;
      }
      targets.forEach(function (t) {
        t.addEventListener('pointerenter', function (e) {
          bub.textContent = t.getAttribute('data-cursor') || '';
          bx = cx = e.clientX; by = cy = e.clientY;
          bub.classList.add('is-on');
          loop();
        });
        t.addEventListener('pointermove', function (e) { bx = e.clientX; by = e.clientY; if (!raf) raf = requestAnimationFrame(loop); });
        t.addEventListener('pointerleave', function () { bub.classList.remove('is-on'); });
      });
    }
  }
})();
